import StantMultiselect from "../../../utils/stant_multiselect.coffee"
import AjaxLoader from "../../../utils/ajax_loader.coffee"

$(document).on 'turbolinks:load', ->
  new StantMultiselect('report-traceabilities-multiselect').add_listener()

  $('#request_form_traceability').on 'submit', ->
    new AjaxLoader().show()
    $('.btn-submit').addClass 'is-disabled'
